import React, { useState } from "react";
import v1 from "../../../assets/svg/job-details-icons/v1.svg";
import v2 from "../../../assets/svg/job-details-icons/v2.svg";
import v3 from "../../../assets/svg/job-details-icons/v3.svg";
import v4 from "../../../assets/svg/job-details-icons/v4.svg";
import v5 from "../../../assets/svg/job-details-icons/v5.svg";
import v6 from "../../../assets/svg/job-details-icons/v6.svg";
import ppo from "../../../assets/svg/job-details-icons/ppo.svg";
import logo from "../../../assets/png/getwork-logo.png";
import company from "../../../assets/svg/job-details-icons/company.svg";
import Dialog from "../../dialog/Dialog";
import OptionInput from "../../input/optionInput/OptionInput";
import { toast } from "react-toastify";
import { BASE_URL_2 } from "../../../customHooks/config";
import axios from "axios";
import Spinner from "../../layout/loader/Spinner";
import { useNavigate } from "react-router-dom";
import OptionInputReason from "../../input/optionInput/OptionInputReason";
import UploadDialog, { USER_DETAILS_UPDATE_UPLOAD_DAILOG } from "./UploadDialog";
import { USER_DETAILS } from "../../layout/Layout";
import { useAtom } from "jotai";
import VerficationMsg from "../../card/dashboardCard/VerficationMsg";

function BasicLeftInfo({ data, state, jobId, setRejected, setIsAccepted }) {
  const [open, setOpen] = useState(false);
  const [loadingRejected, setLoadingRejected] = useState(false);
  const [loadingAccepted, setLoadingAccepted] = useState(false);
  const [userDetails] = useAtom(USER_DETAILS);
  const statusForShowingPopUp =  userDetails?.data?.user_details?.vendor_status;
  const fileValue =  userDetails?.data?.user_details?.file;

  const [rejection, setRejection] = useState({
    reasonDropDown: {},
    disabled: true,
    reasonTextBox: "",
  });
  const navigate = useNavigate();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setRejection({
      ...rejection,
      reasonDropDown: {},
      disabled: true,
      reasonTextBox: "",
    });
  };

  const handleClickAccepted = (row) => {
    setLoadingAccepted(true);
    axios
      .post(
        `${BASE_URL_2}job/vendor/job/?job_id=${jobId}`,
        { status: "ACCEPTED" },
        { withCredentials: true }
      )
      .then((res) => {
        if (res?.data?.success) toast.success(res?.data?.data?.message);
        else toast.error(res?.data?.data?.error);
        setLoadingAccepted(false);
        setIsAccepted(true);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
        setLoadingAccepted(false);
      });
  };

  const handleClickRejected = () => {
    let response = null;
    if (rejection && rejection?.reasonDropDown?.id !== 7)
      response = rejection?.reasonDropDown?.reason;
    if (
      rejection &&
      rejection?.reasonDropDown?.id === 7 &&
      !rejection?.disabled &&
      rejection?.reasonTextBox
    )
      response = rejection?.reasonTextBox;
    if (response) {
      setLoadingRejected(true);
      axios
        .post(
          `${BASE_URL_2}job/vendor/job/?job_id=${jobId}`,
          { status: "REJECTED", reject_reason: response },
          { withCredentials: true }
        )
        .then((res) => {
          if (res?.data?.success) toast.success(res?.data?.data?.message);
          else toast.error(res?.data?.data?.message);

          setLoadingRejected(false);
          setRejected(true);
          handleClose();
        })
        .catch((err) => {
          toast.error(err?.data?.error);
          setLoadingRejected(false);
        });
    }
  };

  function helper() {
    if (data?.job_type_name === "Full Time Job") {
      
      let max = Number(String(data?.ctc_max).slice(0, 2));
      let min = Number(String(data?.ctc_min).slice(0, 2));
      max = (data?.ctc_max<1000000) ?  parseFloat(max/10) : max;
      min = (data?.ctc_min<1000000) ? parseFloat(min/10) : min;

      return `₹ ${min} - ${max}  LPA`;
    } 
    else  {
      let max = Number(String(data?.ppo_ctc_max).slice(0, 2));
      let min = Number(String(data?.ppo_ctc_min).slice(0, 2));
      max = (data?.ctc_max<1000000) ?  parseFloat(max/10) : max;
      min = (data?.ctc_min<1000000) ? parseFloat(min/10) : min;

      return `₹ ${min} - ${max}  LPA`;
  }
}

  function stipend (){
      return `₹ ${data?.stipend}`;
  }

  const jobData = [
    {
      icons: v1,
      title: "Start Date",
      details: data?.apply_start_date_formatted ?? "__",
    },
    {
      icons: v2,
      title: "End Date",
      details: data?.apply_end_date_formatted ?? "__",
    },
    {
      icons: v3,
      title: "Work Exp",
      details: data?.eligibility_criteria?.experience[0] ?? "__",
    },
    {
      icons: v4,
      title: data?.job_type_name === "Internship" ? "Stipend" : "CTC",
      details: data?.job_type_name === "Internship" ? stipend() : helper(),
    },
    {
      icons: ppo,
      title: data?.job_type_name === "Internship" ? "PPO" : "---",
      details: data?.ppo ? "Yes" : "No",
      hide:data?.job_type_name === "Internship"
    },
    {
      icons: v4,
      title: data?.job_type_name === "Internship" ? "CTC" : "---",
      details: data?.job_type_name === "Internship" ? helper() : "---",
      hide:data?.job_type_name === "Internship"
    },
    {
      icons: v5,
      title: "Employment",
      details: data?.job_type_name ?? "",
    },
    {
      icons: v6,
      title: "Service Bond",
      details: data?.service_bond
        ? "Yes" + " ( " + data?.service_bond + " ) "
        : "_",
    },

  ];

  const handleClickUpload = () => {
    // navigate(`/upload-candidate/${jobId}/${data?.company?.company_id}`)
    navigate(`/upload-candidate/`);
  };
  const [openUpload, setOpenUpload] = useState(false);
      
  const handleClickOpenUpload = () => {
   setOpenUpload(true);
  };

  const handleAccept = () =>{
    if(statusForShowingPopUp === "PENDING" && fileValue) toast.success("Your Profile is in Pending Stage")
    else handleClickOpenUpload();
  }

  const DialogActions = (btnColor) => {
    return (
      <>
        {" "}
        <div className="grid grid-cols-2 gap-4 px-7 py-7 ">
          <div>
            <button
              type="button"
              className="w-full text-white rounded-md bg-[#EF4444] h-[40px] "
              onClick={handleClickRejected}
            >
              {loadingRejected ? <Spinner color="red" /> : "Submit"}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="w-full text-[#6C757D] border border-[#6C757D] rounded-md h-[40px]"
              onClick={handleClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </>
    );
  };
  return (!state?.status) ? (<>
      <div className="border bg-white border-[#CBD5E1]  rounded-lg p-5">
        <div className="flex h-[60px] w-[110px] rounded-md  ">
          <img
            className=" aspect-auto w-full object-contain"
            alt="company-logo"
            src={data?.company?.company_logo ?? company}
          />
        </div>

        <div className="mt-3">
          <h2 className="text-lg ">{data?.job_title ?? ""}</h2>
          <p className="text-sm text-[#6C757D] ">
            {data?.company?.company_name ?? ""}
          </p>
        </div>
        {jobData.map((item) => (
 
        item?.hide === false ? (<></>):         
          (<div className="mt-5 flex items-center">
            <div className="flex items-center w-[100px] ">
              <img src={item.icons} alt="icons" />
              <p className=" text-xs pl-1 ">{item.title} :</p>{" "}
            </div>
            <p className="text-[#6C757D] pl-3 text-xs  ">{item.details}</p>
          </div>)
        ))}

            <div className="mt-6 grid grid-cols-1 gap-4  ">
            <div>
              <button
                className=" w-full h-[40px] text-sm text-white bg-[#0DA06A] rounded-md "
                onClick={handleAccept}
              >
                Accept
              </button>
            </div>
          </div>
      </div>
      <div>
      <UploadDialog open={openUpload} setOpen={setOpenUpload} handleClickOpen={handleClickOpenUpload} />

      </div>
    </>
    ):(
    <>
      <div className="border bg-white border-[#CBD5E1]  rounded-lg p-5">
        <div className="flex h-[60px] w-[110px] rounded-md  ">
          <img
            className=" aspect-auto w-full object-contain"
            alt="company-logo"
            src={data?.company?.company_logo ?? company}
          />
        </div>

        <div className="mt-3">
          <h2 className="text-lg ">{data?.job_title ?? ""}</h2>
          <p className="text-sm text-[#6C757D] ">
            {data?.company?.company_name ?? ""}
          </p>
        </div>
        {jobData.map((item) => (
 
        item?.hide === false ? (<></>):         
          (<div className="mt-5 flex items-center">
            <div className="flex items-center w-[100px] ">
              <img src={item.icons} alt="icons" />
              <p className=" text-xs pl-1 ">{item.title} :</p>{" "}
            </div>
            <p className="text-[#6C757D] pl-3 text-xs  ">{item.details}</p>
          </div>)
        ))}
        {state?.status === "ACCEPTED" ? (
          state?.job_status === "OPEN" ? (
            <div className="mt-4">
              <button
                className=" w-full h-[40px] text-sm text-white bg-[#2563EB] rounded-md "
                onClick={handleClickUpload}
              >
                Upload Candidate
              </button>
            </div>
          ) : (
            <>
              {" "}
              <button
                className=" w-full mt-4 bg-white text-sm text-[#EF4444]  h-[40px] border border-[#EF4444] rounded-md  "
                disabled={true}
              >
                Close
              </button>
            </>
          )
        ) : state?.status === "PENDING" ? (
          state?.job_status === "CLOSE" ? (
            <>
              {" "}
              <button
                className=" w-full mt-4 bg-white text-sm text-[#EF4444]  h-[40px] border border-[#EF4444] rounded-md  "
                disabled={true}
              >
                Closed
              </button>
            </>
          ) : (
            <div className="mt-6 grid grid-cols-1 gap-4  ">
              <div>
                <button
                  className=" w-full h-[40px] text-sm text-white bg-[#0DA06A] rounded-md "
                  onClick={handleClickAccepted}
                >
                  {loadingAccepted ? <Spinner color="green" /> : "Accept"}
                </button>
              </div>
              <div>
                <button
                  onClick={handleClickOpen}
                  className=" w-full bg-white text-sm text-[#EF4444]  h-[40px] border border-[#EF4444] rounded-md  "
                >
                  Reject
                </button>
              </div>
            </div>
          )
        ) : state?.job_status === "CLOSE" ? (
          <>
            {" "}
            <button
              className=" w-full mt-4 bg-white text-sm text-[#EF4444]  h-[40px] border border-[#EF4444] rounded-md  "
              disabled={true}
            >
              Closed
            </button>
          </>
        ) : (
          <div className="mt-6 grid grid-cols-1 gap-4  ">
            <div>
              <button
                className=" w-full h-[40px] text-sm text-white bg-[#0DA06A] rounded-md "
                onClick={handleClickAccepted}
              >
                {loadingAccepted ? <Spinner color="green" /> : "Accept"}
              </button>
            </div>
          </div>
        ) }
      </div>
      <div>
        <Dialog
          visible={open}
          title={"Are you sure you want to reject this job ?"}
          handleCloseDialog={handleClose}
          actionsPannel={DialogActions("bg-green")}
          size={"w-2/7"}
          color={"bg-green"}
        >
          <div className="h-[200px]">
            <OptionInputReason
              placeholder="Select Your Reason"
              data={assignData}
              filter={rejection}
              setFilter={setRejection}
            />
            {rejection?.reasonDropDown?.id === 7 && (
              <textarea
                id="message"
                rows="4"
                className="block p-2.5 mt-5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                placeholder="Write your thoughts here..."
                onChange={(e) =>
                  setRejection({
                    ...rejection,
                    disabled: false,
                    reasonTextBox: e.target.value,
                  })
                }
              />
            )}
          </div>
        </Dialog>
      </div>
    </>
  );
}

export default BasicLeftInfo;

const assignData = [
  {
    id: 1,
    reason: "payout is less",
  },
  {
    id: 2,
    reason: "do not have relevant candidates",
  },
  {
    id: 3,
    reason: "not working for tech hiring",
  },
  {
    id: 4,
    reason: "not working for non tech hiring",
  },
  {
    id: 5,
    reason: "job details are not clear",
  },
  {
    id: 6,
    reason: "job is not looks profitable",
  },
  {
    id: 7,
    reason: "Other",
  },
];
